import React from 'react';
import './loader.css';

const Loader = ({ dimensions }) => {
  // Destructure dimensions from props
  return (
    <div
      className="loader"
      style={{ '--loader-size': dimensions }} // Pass dimensions as a CSS variable
    ></div>
  );
};

export default Loader;
